<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
            <div class="form-group has-search my-2">
                        <span class="fa fa-search form-control-product-feedback "></span>
                    <input
                    @input="onQuickFilterChanged()"
                    id="quickFilter"
                    v-model="searchProduct"
                    class="filter_input_product form-control-product"
                    >
                </div>
          <div class="d-flex flex-wrap">
            <active-only
              class="mt-1 ml-3"
              @toggle="SearchWithField($event, 'status')"
            />
          </div>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'admin-product-add' })"
          >Add Product</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        class="pagination"
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import vSelect from 'vue-select'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

// Cell Renderer components
import CellRendererActions from './cell-renderer/CellRendererActions'
import CellRendererStatus from './cell-renderer/CellRendererStatus'

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,
    vSelect,
    //Cell Renderer components
    CellRendererActions,
    CellRendererStatus

  },
  data() {
    return {
      // table header value
      columnDefs: [
        {
          headerName: 'Status',
          flex: 0,
          cellRendererFramework: 'CellRendererStatus',
          minWidth: 100,
        },
        {
          headerName: 'Product Name',
          field: 'product_name',
          sortable: true,
          unSortIcon: true,
          minWidth: 220,
          flex: 7
        },
        {
          headerName: 'Created On',
          field: 'created_on',
          sortable: 'asc',
          unSortIcon: true,
          minWidth: 220,
          flex: 5
        },
        {
          headerName: 'Created By',
          field: 'created_by',
          minWidth: 220,
          flex: 5
        },
        {
          headerName: 'Type',
          field: 'public',
          minWidth: 180,
          flex: 3
        },
        {
          headerName: 'Action',
          minWidth: 180,
          flex: 3,
          cellRendererFramework: 'CellRendererActions',
        }
      ],

      // Cell Renderer components
      components: {
        CellRendererActions,
        CellRendererStatus
      },
      searchProduct: ''
    }
  },
  created() {
    this.GetList()
  },

  methods: {
    GetList() {
      this.$vs.loading()
      this.$store.dispatch('product/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'product_name',
        order_dir: this.order_dir || 'desc',
        product_name: this.searchProduct + '*'
      })
      .then(res => {
        this.list = res.items.map(this.TransformReseller)
        this.total = res.total
        console.log(this.list,"--------")
      })
      .catch()
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    SearchWithField (e, field) {
      if (!e) delete this.filters[field]
      else {
        if (typeof e === 'object') this.filters[field] = e.value
        else this.filters[field] = e
      }

      this.GetList()
    },
    TransformReseller(item) {
      return {
        refreshData: this.GetList,
        status: item.status === 'active' ? true : false,
        product_name: item.product_name,
        product_uuid: item.product_uuid,
        created_by: item.created_by,
        created_on: format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
        public : item.public ? 'Public' : 'Private'
      }
    },
    onQuickFilterChanged() {
      this.GetList()
      // console.log(this.gridApi)
      // this.gridApi.setQuickFilter(document.getElementById('quickFilter').value);
    },
  },

}
</script>
<style>
    .filter_input_product{
        padding: 17px;
        padding-left: 55px;
        width: 300px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
    }
    .has-search .form-control-product-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 35px;
        margin-top: 20px;
    }
</style>
<style scoped lang="scss">
  /*.pagination ::v-deep .vs-pagination--li{
    width: auto;
    min-width: 35px!important;
    padding: 0 3px!important;

  }*/
/*  .pagination  ::v-deep .vs-pagination--li.is-current .effect{
    border-radius: 35px!important;
  }*/
</style>
